import React, { useState, useEffect, createContext } from 'react';
import moment from 'moment';
import { navigate } from 'gatsby';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { GetLeadStatus } from '../../common/constants/api';
import { siteTitle } from '../../../data/SiteConfig';
import TopBarFiltersForRm from '../../components/TopbarFiltersForRm/TopbarFiltersForRm';
import Table from '../../components/Table/LemsTable';
import CMColumn from './CMColumn';
import { getLeadDataInCMDashboard } from '../../common/constants/api';
import PopUp from '../../common/components/PopUp/PopUp';
import * as _ from 'lodash';
import Audit from '../../containers/Audit/Audit';
import CommonBtn from '../../containers/LeadProfile/CommonBtn/CommonBtn';
import { getApplicantionInfo } from '../../common/utils/applicantionInfo';
import { getFiltersInfo, setFiltersInfo } from '../../common/utils/FiltersInfo';
import './CMDashboard.scss';
import TargetMonthFilter from '../../components/DashboardTargetMonthFilter/TargetMonthFilter';

export const StateExporter = createContext();

const CMDashboard = ({ user }) => {
  const [startDate, setStartDate] = useState(
    getFiltersInfo()?.fromDate || moment().format('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState(
    getFiltersInfo()?.toDate || moment().format('YYYY-MM-DD')
  );
  const [rmId, setRmId] = useState(getFiltersInfo()?.rmId || '');
  const [TableData, setTableData] = useState([]);
  const [FilterStatus, setFilterStatus] = useState('');
  const [searchedValue, setSearchValue] = useState(
    getFiltersInfo()?.searchValue || ''
  );
  const [detailView, setDetailView] = useState(false);
  const [columnData, setColumnData] = useState([]);
  const [show, setShow] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('loading...');
  const [filteredData, setFilteredData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableInfo, setTableInfo] = useState({});
  const [status, setStatus] = useState(false);
  const [productType, setProductType] = useState(false);
  const [size, setTableSize] = useState('50');
  const [page, setPage] = useState('0');
  const [column, setColumn] = useState(false);
  const [pagsortDir, setSortDir] = useState(false);
  const [showAuditTrail, setShowAuditTrail] = useState(false);
  const [handleAuditTrail, setHandler] = useState(false);
  const [firstLoading, setFirstLoading] = useState(true);
  const [doRender, setDoRender] = useState(true);

  const [statusFilterData, setStatusFilterData] = useState(
    getFiltersInfo()?.cmStatusFilters || false
  );
  const [productFilterData, setProductFilterData] = useState(
    getFiltersInfo()?.cmProductFilter || false
  );
  const [changeMonth, setChangeMonth] = useState(
    getFiltersInfo()?.targetMonth || undefined
  );

  const customHandlePerRowsChange = (perPage, page) => {
    getNewData(status, productType, '0', perPage, column, pagsortDir, false);
    setTableSize(perPage);
    setPage(page - 1);
  };

  const customHandlePageChange = async page => {
    try {
      const response = await getNewData(
        status,
        productType,
        page,
        size,
        column,
        pagsortDir,
        false
      );
    } catch (error) {}
  };

  const customHandleSort = (column, sortDirection) => {
    if (column.selector) {
      getNewData(
        status,
        productType,
        page,
        size,
        column.selector,
        sortDirection,
        false
      );
      setSortDir(sortDirection);
      setColumn(column.selector);
    }
  };

  const searchField = e => {
    setSearchValue(e?.target?.value || e);
    getNewData(
      statusFilterData || '',
      productFilterData || '',
      0,
      size,
      false,
      false,
      e?.target?.value || e
    );
  };
  useEffect(() => {
    setColumnData(CMColumn(setDetailView));
  }, []);

  const getNewData = (
    status = statusFilterData || '',
    product_type = productFilterData || '',
    page_no = page,
    page_size = size,
    sort = '',
    sortDir = '',
    searchBy = searchedValue || ''
  ) => {
    setTableLoading(true);
    return getLeadDataInCMDashboard(
      startDate,
      endDate,
      status,
      product_type,
      page_no,
      page_size,
      sort,
      sortDir,
      searchBy,
      changeMonth ? `${changeMonth.year}-${changeMonth.month}-28` : '',
      rmId
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setTableData(_.get(res, '_embedded.customers', []));
        setTableLoading(false);
        setTableInfo(_.get(res, 'page', {}));
        setFirstLoading(false);
        return res;
      })
      .catch(error => {
        setTableLoading(false);
        setType('fail');
        setText(error?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (startDate && endDate && !firstLoading) getNewData();
  }, [startDate, endDate, statusFilterData, productFilterData, rmId]);

  useEffect(() => {
    getNewData();
  }, []);
  const customeFilterFunction = () => TableData;

  useEffect(() => {
    if (detailView) {
      if (user == 'rm') {
        setFiltersInfo(
          Object.assign(getFiltersInfo() || {}, {
            user: 'rm',
            detailView: true
          })
        );
      }
      navigate(`/app/documents/leadId/${getApplicantionInfo().leadId}`);
    }
  }, [detailView]);

  useEffect(() => {
    if (!showAuditTrail)
      setTimeout(function() {
        setHandler(false);
      }, 1000);
  }, [showAuditTrail]);

  useEffect(() => {
    let cmFilters = getFiltersInfo();
    if (typeof cmFilters == 'object') {
      cmFilters['fromDate'] = startDate;
      cmFilters['toDate'] = endDate;

      setFiltersInfo(cmFilters);
    } else {
      setFiltersInfo({
        fromDate: startDate,
        toDate: endDate
      });
    }
  }, [startDate, endDate]);

  const ActionOnFilterProduct = () => {
    let productFilter = '';

    let filterProducts = FilterStatus?.Product;
    if (typeof filterProducts == 'object') {
      let listOfProducts = Object.keys(filterProducts);
      listOfProducts.map((each, index) => {
        if (filterProducts[each]) {
          productFilter = `${productFilter}${
            index != listOfProducts.length && productFilter ? ',' : ''
          }${each}`;
        }
      });
    }
    setProductFilterData(productFilter);
    setCmFilterData('cmProductFilter', productFilter);
  };

  const actionOnFilterStatus = () => {
    let statusFilters = '';
    let status = FilterStatus?.Status;

    if (typeof status == 'object') {
      let listOfStatus = Object.keys(status);
      listOfStatus.map((each, index) => {
        if (status[each]) {
          statusFilters = `${statusFilters}${
            index != listOfStatus.length && statusFilters ? `,` : ''
          }${each}`;
        }
      });
    }
    setStatusFilterData(statusFilters);
    setCmFilterData('cmStatusFilters', statusFilters);
  };

  const setCmFilterData = (key, value) => {
    let cmFilters = getFiltersInfo();

    if (typeof cmFilters == 'object') {
      cmFilters[key] = value;
      setFiltersInfo(cmFilters);
    } else {
      setFiltersInfo({
        key: value
      });
    }
  };

  useEffect(() => {
    setCmFilterData('searchValue', searchedValue);
  }, [searchedValue]);

  useEffect(() => {
    if (firstLoading || FilterStatus?.firstLoading) return;
    ActionOnFilterProduct();

    actionOnFilterStatus();
  }, [FilterStatus, doRender]);

  useEffect(() => {
    if (typeof changeMonth != undefined) {
      getNewData();
      setCmFilterData('targetMonth', changeMonth);
    }
  }, [changeMonth]);

  useEffect(() => {
    if (user == 'rm')
      setFiltersInfo(
        Object.assign(getFiltersInfo() || {}, {
          detailView: false
        })
      );
  }, []);

  return (
    <React.Fragment>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0 ">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          {handleAuditTrail ? (
            <Audit
              setShowAuditTrail={setShowAuditTrail}
              showAuditTrail={showAuditTrail}
            />
          ) : null}

          <div className="widhtMd max-screen flex-1  w-full ">
            <Header />

            <React.Fragment>
              <div className="w-full flex flex-wrap items-center">
                <StateExporter.Provider
                  value={{
                    startDate,
                    setStartDate,
                    endDate,
                    setEndDate
                  }}
                >
                  <TopBarFiltersForRm itsCM user={user} />
                  <div className="mt-6 ml-5">
                    <TargetMonthFilter
                      setChangeMonth={e => {
                        setChangeMonth(e);
                      }}
                      changeMonth={changeMonth}
                      placeholder="Select Month"
                      targetMonthRange={{
                        min: {
                          year: moment().format('YYYY') - 30,
                          month: 1,
                          date: 28
                        },
                        max: {
                          year: moment().format('YYYY'),
                          month: moment().month() + 1,
                          date: 28
                        }
                      }}
                    />
                  </div>
                </StateExporter.Provider>
                {detailView ? (
                  <div
                    className="mt-6 float-right ml-auto flex"
                    style={{ width: 'fit-content' }}
                  >
                    <CommonBtn
                      value="Audit Trail"
                      onClick={() => {
                        setHandler(true), setShowAuditTrail(true);
                      }}
                    />
                  </div>
                ) : null}
              </div>

              <div className="w-full cmDashboard">
                <Table
                  rm
                  rmId={rmId}
                  setRmId={setRmId}
                  dontShowAutoFilter={false}
                  setFilterStatus={setFilterStatus}
                  Search=""
                  data={TableData ? TableData : []}
                  StatusOPtion={[]}
                  StatusFilter={FilterStatus}
                  columns={columnData}
                  serverPagination
                  serverPaginationUrl={getLeadDataInCMDashboard}
                  CustomhandlePerRowsChange={(perPage, page) =>
                    customHandlePerRowsChange(perPage, page)
                  }
                  CustomhandlePageChange={customHandlePageChange}
                  CustomhandleSort={customHandleSort}
                  searchUrl={searchField}
                  CustomhandleSearch={searchField}
                  serverSort={true}
                  customeFilter={true}
                  customeFilterFunction={customeFilterFunction}
                  TableInfo={tableInfo}
                  tableLoading={tableLoading}
                  filterName="status"
                  filterComponent
                  GetLeadStatus={() => GetLeadStatus('cm')}
                  tableListbelongs="Leads"
                  searchName="leadId"
                  filterCaption="status"
                  serchBarPlaceHolder="Search by name , Lead ID or Mobile No"
                  rows="50"
                  getFiltersRawObject={true}
                  filterProductType={productFilterData}
                  searchvalue={searchedValue}
                  user="cm"
                  setDoRender={setDoRender}
                  doRender={doRender}
                />
              </div>
            </React.Fragment>
          </div>
        </div>
        <PopUp type={type} text={text} setShow={setShow} show={show} />
      </div>
    </React.Fragment>
  );
};

export default CMDashboard;
